import script from "./itemV2Variants.vue?vue&type=script&setup=true&lang=ts"
export * from "./itemV2Variants.vue?vue&type=script&setup=true&lang=ts"

import "./itemV2Variants.vue?vue&type=style&index=0&id=7b9c3d16&lang=css"

const __exports__ = script;

export default __exports__